import { Brand } from 'constants/brand';
import FeesTable from 'containers/Brokers/MyCommission/FeesTable';
import TradesTable from 'containers/Brokers/MyCommission/TradesTable';

export const MY_COMMISSION_COM_SOURCE_CONFIG = {
  [Brand.FM]: { title: 'Trades', Component: TradesTable },
  [Brand.GP]: { title: 'Trades', Component: TradesTable },
  [Brand.DAY1]: { title: 'Fees', Component: FeesTable },
};
